// show/hide search

const body = $('body');
const searchTrigger = $('.js-search-trigger, .navbar-toggler, .js-close-search-trigger');
const searchForm = $('.js-needs-validation');

if (searchTrigger) {
  searchTrigger.click((e) => {
    e.preventDefault();
    body.toggleClass("js-search-open");
    searchForm.removeClass('was-validated');
  });
}

if (searchForm) {
  // validation
  searchForm.submit((e) => {
    if (searchForm.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      searchForm.addClass('was-validated');
    }
  });
}

$(window).resize(() => { 
  $(".navbar-collapse.collapse.show").removeClass("show");
  body.removeClass("js-search-open");
  searchForm.removeClass('was-validated');
});
